import { render } from "./LocationsView.vue?vue&type=template&id=b716a1a8"
import script from "./LocationsView.vue?vue&type=script&lang=js"
export * from "./LocationsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__